import { withInstall } from '@fx-front-framework/utils/with-install'
import VColumnChart from './src/index.vue'

export const FxVColumnChart = withInstall(VColumnChart)
export default FxVColumnChart

export * from './src/types'
